export default __webpack_public_path__ + "static/media/noPaymentRequiredIconEmpty.bbbc2929.svg";